import apiService from '../../../core/services/API';
import {environment} from '../../../environments/environment';

export function changePassword(data) {
    return apiService.post({
        url: `${environment.api.changePassword}`,
        data
    });
}
